// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IFieldStateType } from './IFieldStateType';
import {
    IFieldStateTypeFromJSON,
    IFieldStateTypeFromJSONTyped,
    IFieldStateTypeToJSON,
    IFieldStateTypeToJSONTyped,
} from './IFieldStateType';

/**
 * 
 * @export
 * @interface IElectronicFundingModeInfoDto
 */
export interface IElectronicFundingModeInfoDto {
    /**
     * 
     * @type {string}
     * @memberof IElectronicFundingModeInfoDto
     */
    electronic_funding_mode: IElectronicFundingModeInfoDtoElectronicFundingModeEnum;
    /**
     * 
     * @type {IFieldStateType}
     * @memberof IElectronicFundingModeInfoDto
     */
    electronic_funding_mode_state?: IFieldStateType;
}

/**
* @export
* @enum {string}
*/
export enum IElectronicFundingModeInfoDtoElectronicFundingModeEnum {
    PARTNER_FUNDED = 'PARTNER_FUNDED',
    EMPLOYER_FUNDED = 'EMPLOYER_FUNDED',
    HIERARCHY_FUNDED = 'HIERARCHY_FUNDED'
}


/**
 * Check if a given object implements the IElectronicFundingModeInfoDto interface.
 */
export function instanceOfIElectronicFundingModeInfoDto(value: object): value is IElectronicFundingModeInfoDto {
    if (!('electronic_funding_mode' in value) || value['electronic_funding_mode'] === undefined) return false;
    return true;
}

export function IElectronicFundingModeInfoDtoFromJSON(json: any): IElectronicFundingModeInfoDto {
    return IElectronicFundingModeInfoDtoFromJSONTyped(json, false);
}

export function IElectronicFundingModeInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IElectronicFundingModeInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'electronic_funding_mode': json['electronic_funding_mode'],
        'electronic_funding_mode_state': json['electronic_funding_mode_state'] == null ? undefined : IFieldStateTypeFromJSON(json['electronic_funding_mode_state']),
    };
}

export function IElectronicFundingModeInfoDtoToJSON(json: any): IElectronicFundingModeInfoDto {
    return IElectronicFundingModeInfoDtoToJSONTyped(json, false);
}

export function IElectronicFundingModeInfoDtoToJSONTyped(value?: IElectronicFundingModeInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'electronic_funding_mode': value['electronic_funding_mode'],
        'electronic_funding_mode_state': IFieldStateTypeToJSON(value['electronic_funding_mode_state']),
    };
}

